export class PsNotificationStates {
    static NO_SOLVED = 0;
    static SOLVED = 1;
    static ALL = 2;
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/PsNotificationStates.js